import React from 'react';
import { Bug, Sparkles, ListTodo, AlertCircle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent } from '@/components/ui/card';

const MisTareasView = ({ solicitudes, loading, currentUserId, onViewDetail, getTipoIcon, getTipoLabel, getPrioridadColor, getEstadoColor, getEstadoLabel }) => {
  const misTareas = solicitudes.filter(s => 
    s.asignadoA?.id === currentUserId || s.creadoPor?.id === currentUserId
  );

  if (loading) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">Cargando tus tareas...</p>
      </div>
    );
  }

  if (misTareas.length === 0) {
    return (
      <Card>
        <CardContent className="py-12 text-center">
          <AlertCircle className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
          <p className="text-muted-foreground">No tienes tareas asignadas</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      {misTareas.map((solicitud) => (
        <Card
          key={solicitud._id}
          className="cursor-pointer hover:shadow-md transition-shadow"
          onClick={() => onViewDetail(solicitud)}
        >
          <CardContent className="p-6">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  {getTipoIcon(solicitud.tipo)}
                  <h3 className="text-lg font-semibold">{solicitud.titulo}</h3>
                </div>
                <p className="text-sm text-muted-foreground mb-3 line-clamp-2">
                  {solicitud.descripcion}
                </p>
                <div className="flex flex-wrap gap-2">
                  <Badge variant={getPrioridadColor(solicitud.prioridad)}>
                    {solicitud.prioridad}
                  </Badge>
                  <Badge className={getEstadoColor(solicitud.estado)}>
                    {getEstadoLabel(solicitud.estado)}
                  </Badge>
                  <Badge variant="outline">{getTipoLabel(solicitud.tipo)}</Badge>
                  {solicitud.modulo && (
                    <Badge variant="secondary">{solicitud.modulo}</Badge>
                  )}
                </div>
              </div>
              <div className="text-right text-sm text-muted-foreground ml-4">
                <p>Creado por: {solicitud.creadoPor?.nombre}</p>
                <p>{new Date(solicitud.fechaCreacion).toLocaleDateString()}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default MisTareasView;
